import { render, staticRenderFns } from "./activemanage.vue?vue&type=template&id=35e59cfc&scoped=true&"
import script from "./activemanage.vue?vue&type=script&lang=js&"
export * from "./activemanage.vue?vue&type=script&lang=js&"
import style0 from "./activemanage.vue?vue&type=style&index=0&id=35e59cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e59cfc",
  null
  
)

export default component.exports